import type { TRuleWithTheme } from 'styles/theme';

export const container: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '52rem',
    margin: '0 auto',
    padding: '2rem 1rem 4rem',
});

export const header: TRuleWithTheme = () => ({
    marginBottom: '1.5rem',
});

export const title: TRuleWithTheme = () => ({
    '&.ant-typography': {
        marginBottom: '0.25rem',
        fontSize: '1.5rem',
        lineHeight: 1.33,
    },
});

export const subtitle: TRuleWithTheme = ({ theme }) => ({
    color: theme.colors.textSecondary,
    fontSize: '0.9375rem',
});

export const inputSection: TRuleWithTheme = () => ({
    marginBottom: '2rem',
});

export const thread: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '1.25rem',
});

export const threadItem: TRuleWithTheme = ({ theme }) => ({
    padding: '1.5rem',
    borderRadius: '0.75rem',
    backgroundColor: theme.colors.white,
    border: `1px solid ${theme.colors.dividerColor}`,
});

export const disclaimer: TRuleWithTheme = ({ theme }) => ({
    marginTop: '0.75rem',
    color: theme.colors.textSecondary,
    fontSize: '0.75rem',
    textAlign: 'center',
});
